import React, { useEffect, useState } from 'react';
import useApi from '../../../../hooks/useQuery';
import { LoadingSpinner } from '../../../../_ePulse/layout/components/LoadingSpinner';
import moment from 'moment';
import useLocalStorageFetch from '../../../../hooks/localStorageFetch';
import { useSelector } from 'react-redux';
import { GET_BUSSINESS_OPERATING_HOURS } from '../GraphQLQueries/Dashboard';


const VisitingHoursScanCenter: React.FC = () => {
  const [visitingHours, setVisitingHours] = useState<any>([]);
  const { role } = useLocalStorageFetch();
  const reduxData: any = useSelector((state) => state);
  const { data, loading } = useApi(true, GET_BUSSINESS_OPERATING_HOURS, {});

  useEffect(() => {
    if (data) {
      const res = data?.getBusinessOperatingHours;
      setVisitingHours(res);
    }
  }, [data]);

  function formatTimings(timings: any) {
    if (!timings?.length) return 'NA';
    let formattedSlots = timings?.map(
      ({ slotStart, slotEnd }: any) =>
        `${moment(slotStart).utc().format('HH:mm')}-${moment(slotEnd).utc().format('HH:mm')}`
    );
    return timings?.length > 2 ? `${formattedSlots[0]}, ...` : formattedSlots?.join(', ');
  }

  function formatTimingsforTooltip(timings: any) {
    if (!timings?.length) return 'NA';
    let formattedSlots = timings?.map(
      ({ slotStart, slotEnd }: any) =>
        `${moment(slotStart).utc().format('HH:mm')}-${moment(slotEnd).utc().format('HH:mm')}`
    );
    return formattedSlots?.join(', ');
  }

  return (
    <div className='visitingHoursContainter'>
      <div className="d-flex flex-column h-100 p-3"> {/* Fill parent div with padding */}
        <LoadingSpinner isLoading={loading} />
        <div className="flex-grow-1 d-flex flex-column"> {/* Allow this div to grow */}
          {visitingHours.length ? (
            <>
              <div className="row py-3 border-bottom"> {/* Added border for separation */}
                <div className="col fw-bold fs-5">Day of week</div> {/* Increased font size */}
                <div className="col fw-bold fs-5">Open/Closed</div> {/* Increased font size */}
                <div className="col fw-bold fs-5">Visiting Hours</div> {/* Increased font size */}
              </div>
              {visitingHours.map((input: any, index: any) => (
                <div key={index} className="row align-items-center py-2"> {/* Added padding for rows */}
                  <div className="col fs-5">{input?.dayOfWeek}</div> {/* Increased font size */}
                  <div className="col fs-5">
                    {input?.isClosed === false ? 'Open' : 'Closed'}
                  </div>
                  <div className="col fs-5"> {/* Increased font size */}
                    {input?.isOpen24Hours ? (
                      <span>24 hours</span>
                    ) : (
                      <>
                        <span>{formatTimings(input?.timings)} </span>
                        <span>
                          <i
                            className="fas fa-exclamation-circle ms-2"
                            data-bs-toggle="tooltip"
                            title={formatTimingsforTooltip(input?.timings)}
                          ></i>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-center flex-grow-1"> {/* Center the message */}
              <span className="fs-5 fw-normal text-center">Visiting hours are not added!!!</span>
            </div>
          )}
        </div>
      </div>
    </div>

  );
};

export { VisitingHoursScanCenter };
